export default "__VITE_ASSET__9VLavE0d__"